import { render } from "./colfocus.vue?vue&type=template&id=51862065"
import script from "./colfocus.vue?vue&type=script&lang=js"
export * from "./colfocus.vue?vue&type=script&lang=js"

import "./colfocus.vue?vue&type=style&index=0&id=51862065&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__